import {IProjectStore} from "./index";

export default {
  id: null,
  cartId: null,
  date: null,
  attributes: [],
  active: ["model", "variant"],
  selectedAttributes: [],
  zoom: 1,
  fliped: false,
  centred: true,
  wall: 1,
  cart: [],
  history: [],
  custom: {},
  loaded: false,
  loading: false,
  expanded: 'model',
  distributors: [],
  searchDist: "",
  selectedDist: [],
  installation: false,
  measurement: false,
  editable: true,
  form: {
    name: "",
    phone: "",
    email: "",
    notes: "",
    agree: false,
  },
} as IProjectStore;
